import script from "./OngoingFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./OngoingFeedback.vue?vue&type=script&setup=true&lang=js"

import "./OngoingFeedback.vue?vue&type=style&index=0&id=48a3ef46&lang=css"

const __exports__ = script;

export default __exports__